// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__Ry32M","content":"Consent_content__1O0kV","footer":"Consent_footer__1F90x"};